export enum SecureStoreEntityType {
  OAuthClient = 'OAuthClient',
  SecretService = 'Secret',
}
